export default (fieldName) => ({
    value: '',
    shouldValidate: false,
    fieldName: fieldName,
    isValidResponse: function() {
        if(this.errors == undefined){
            throw new Error('You should initialize the form data first');
        }
        const isValid = this.value.length > 0
        this.setError(this.fieldName, isValid ? [] : ['invalid'])
        if(this.shouldValidate){
            return isValid;
        }
        return true;
    },
})